/**
 * Which way round a column is read.
 *
 * Sent only alongside a column. Left out, the backend applies the direction that column is read
 * in — newest leads first, companies from A — so the first click on a heading lands on the order
 * somebody expected rather than on its reverse.
 */
export type SortDirection = 'ASC' | 'DESC'

/** What the next click on a heading asks for: the same column the other way round. */
export function opposite(direction: SortDirection): SortDirection {
  return direction === 'ASC' ? 'DESC' : 'ASC'
}
